import { render, staticRenderFns } from "./PatientSearch.vue?vue&type=template&id=6e989456&scoped=true"
import script from "./PatientSearch.vue?vue&type=script&lang=js"
export * from "./PatientSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e989456",
  null
  
)

export default component.exports